// pages/LoginEmail.js
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchSignInMethodsForEmail, sendPasswordResetEmail, sendSignInLinkToEmail } from 'firebase/auth';
import { auth, db } from '../../config/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { login, register } from '../../features/auth/authSlice';
import { createUser } from '../../features/user/userSlice'
import "../../i18n";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";


import { toast } from 'react-toastify';
import loginimg from "../../images/login-bg-1.jpg";
import beetinqlogowhite from "../../images/beetinq/beetinqlogowhite.png";
import { Link, useNavigate } from "react-router-dom";

function LoginEmail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const [stage, setStage] = useState('email'); // 'email' | 'password' | 'register'
  const [inputEmail, setInputEmail] = useState('');
  const [forgotEmailError, setForgotEmailError] = useState(false);
  const [forgotEmailSuccess, setForgotEmailSuccess] = useState(false);
  const [forgotEmailErrorMsg, setForgotEmailErrorMsg] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [pwdError, setPwdError] = useState(false);

  const userDocExists = async (uid) => {
    try {
      const ref = doc(db, 'users', uid);
      const snap = await getDoc(ref);
      return snap.exists();
    } catch (e) {
      // If check fails, assume exists to be safe and avoid overwriting
      return true;
    }
  };

  const handleEmailContinue = async (e) => {
    e?.preventDefault();
    if (!inputEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputEmail)) {
      toast.warning(t("please enter a valid email"));
      return;
    }
    try {
      setLoading(true);
      const methods = await fetchSignInMethodsForEmail(auth, inputEmail);
      if (methods && methods.includes('password')) {
        setStage('password');
      } else if (!methods || methods.length === 0) {
        setStage('register');
      } else {
        alert(t("this email address is registered with a different provider. please use the appropriate provider."));
      }
    } catch (error) {
      toast.error(t("email check failed:") + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordLogin = async (e) => {
    e?.preventDefault();
    if (!password) {
      toast.warning(t("please enter your password"));
      return;
    }
    try {
      setLoading(true);
      const user = await dispatch(login({ email: inputEmail, parola: password })).unwrap();
      toast.success(t("login successful"));
      setPwdError(false);
      const exists = await userDocExists(user?.uid);
      if (!exists) {
        await dispatch(createUser(user));
        navigate('/RegisterProfile');
      } else {
        navigate('/');
      }
    } catch (error) {
      setPwdError(true);
      toast.error(t("login failed") + (error || t("error")));
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e?.preventDefault();
    if (!password) {
      toast.warning(t("please set a password"));
      return;
    }
    try {
      setLoading(true);
      const user = await dispatch(register({ email: inputEmail, parola: password })).unwrap();
      toast.success(t("registration successful"));
      if (user) {
        await dispatch(createUser({
          uid: user.uid,
          phoneNumber: user.phoneNumber ?? "",
          email: user.email ?? inputEmail
        }));
        navigate('/RegisterProfile');
      }
    } catch (error) {
      toast.error(t("registration failed: ") + (error || t("error")));
    } finally {
      setLoading(false);
    }
  };

  const resetToEmail = () => {
    setStage('email');
    setPassword('');
    setPwdError(false);
    setForgotEmailError(false);
    setForgotEmailSuccess(false);
    setForgotEmailErrorMsg('');
  };

  const handleForgotPassword = async () => {
    try {
      if (!inputEmail) {
        setForgotEmailError(true);
        setForgotEmailSuccess(false);
        setForgotEmailErrorMsg('');
        toast.warning(t("enter your email to reset"));
        return;
      }
      setForgotEmailError(false);
      setForgotEmailErrorMsg('');
      setLoading(true);
      await sendPasswordResetEmail(auth, inputEmail);
      toast.success(t("password reset link sent"));
      setForgotEmailSuccess(true);
    } catch (error) {
      setForgotEmailSuccess(false);
      setForgotEmailErrorMsg(error?.message || t("password reset failed"));
      toast.error(t("password reset failed") + (error?.message || error || t("error")));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper" style={{ position: "relative" }}>
      <LanguageSwitcher />
      <div className="login-aside-left" style={{ backgroundImage: "url(" + loginimg + ")" }}>
        <Link to="/" className="login-logo">
          <img src={beetinqlogowhite} alt="" width={"60%"} />
        </Link>
        <div className="login-description">
          <h2 className="text-white mb-4">{t("your meetings")}<br></br>{t("your business activities")}<br></br>{t("common platform for")}</h2>
          <p className="fs-16">{t("create, share, and collaborate on meetings and business events with beetinq. Take your place on the largest business networking platform.")}</p>
          <ul className="social-icons mt-4">
            <li><Link to={"https://www.facebook.com/beetinq"}><i className="fa fa-facebook"></i></Link></li>
            <li><Link to={"https://www.instagram.com/beetinq"}><i className="fa fa-instagram"></i></Link></li>
            <li><Link to={"https://www.linkedin.com/company/beetinq"}><i className="fa fa-linkedin"></i></Link></li>
            <li><Link to={"https://beetinq.com"}><i className="fa fa-globe"></i></Link></li>
          </ul>
          <div className="mt-5">
            <Link to={"https://beetinq.com/"} className="text-white">© 2021 beetinq</Link>
          </div>
        </div>
      </div>
      <div className="login-aside-right">
        <div className="row m-0 justify-content-center h-100 align-items-center">
          <div className="col-xl-6 col-xxl-8">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    {stage === 'email' && (
                      <>
                        <div className=" mb-3">
                          <h2 className="text-info">{t("welcome")}</h2>
                        </div>
                        <h4 className=" mb-4 ">{t("sign in by entering your information")}</h4>
                        <form onSubmit={handleEmailContinue}>
                          <div className="form-group mb-3">
                            <label className="">
                              <strong>{t("your email address")}</strong>
                            </label>
                            <input
                              type="email"
                              className="form-control  mb-3"
                              value={inputEmail}
                              onChange={(e) => {
                                setInputEmail(e.target.value);
                                if (forgotEmailError) setForgotEmailError(false);
                                if (forgotEmailSuccess) setForgotEmailSuccess(false);
                                if (forgotEmailErrorMsg) setForgotEmailErrorMsg('');
                              }}
                              placeholder={t("email")}
                            />
                            {forgotEmailError && (
                              <div className="text-danger mt-2">
                                {t("email required")}
                              </div>
                            )}
                            {!!forgotEmailErrorMsg && (
                              <div className="text-danger mt-2">
                                {forgotEmailErrorMsg}
                              </div>
                            )}
                            {forgotEmailSuccess && (
                              <div className="mt-2" style={{ color: "#16a34a", fontWeight: 600 }} aria-live="polite">
                                {t("password reset link sent")}
                              </div>
                            )}
                            <label className="">
                              {t("enter your email address and continue.")}
                            </label>
                          </div>
                          <div className="text-start mb-3">
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={handleForgotPassword}
                              disabled={loading}
                            >
                              {t("i forgot my password")}
                            </button>
                          </div>
                          {forgotEmailSuccess && (
                            <div className="mt-2 mb-3" style={{ color: "#16a34a", fontWeight: 600 }} aria-live="polite">
                              {t("password reset link sent")}
                            </div>
                          )}
                          <div className="text-center">
                            <button type="submit" className="btn btn-info btn-block" disabled={loading}>
                              {loading ? t("please wait...") : t("next")}
                            </button>
                          </div>
                        </form>

                        <div id="recaptcha"></div>
                      </>
                    )}

                    {stage === 'password' && (
                      <>
                        <div className=" mb-3">
                          <h2 className="text-info">{t("login with password")}</h2>
                        </div>
                        <h5 className=" mb-2 ">{inputEmail}</h5>
                        <form onSubmit={handlePasswordLogin}>
                          <div className="form-group mb-3">
                            <label className="">
                              <strong>{t("password")}</strong>
                            </label>
                            <input
                              type="password"
                              className="form-control  mb-3"
                              value={password}
                              onChange={(e) => { setPassword(e.target.value); if (pwdError) setPwdError(false); }}
                              placeholder={t("password")}
                            />
                            {pwdError && (
                              <div className="text-danger mb-2">{t("the password is incorrect. please try again.")}</div>
                            )}
                          </div>
                          <div className="text-center">
                            <button type="submit" className="btn btn-info btn-block" disabled={loading}>
                              {loading ? t("please wait...") : t("login")}
                            </button>
                          </div>
                        </form>
                        <div className="text-center mt-3">
                          <button type="button" className="btn btn-outline-info btn-block" onClick={resetToEmail}>
                            {t("back")}
                          </button>
                        </div>
                      </>
                    )}

                    {stage === 'register' && (
                      <>
                        <div className=" mb-3">
                          <h2 className="text-info">{t("sign up")}</h2>
                        </div>
                        <h5 className=" mb-2 ">{inputEmail}</h5>
                        <form onSubmit={handleRegister}>
                          <div className="form-group mb-3">
                            <label className="">
                              <strong>{t("set password")}</strong>
                            </label>
                            <input
                              type="password"
                              className="form-control  mb-3"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              placeholder={t("password")}
                            />
                            <label className="">
                              {t("this is your first time logging in with your email address. please set a password.")}
                            </label>
                          </div>
                          <div className="text-center">
                            <button type="submit" className="btn btn-info btn-block" disabled={loading}>
                              {loading ? t("please wait...") : t("sign up")}
                            </button>
                          </div>
                        </form>
                        <div className="text-center mt-3">
                          <button type="button" className="btn btn-outline-info btn-block" onClick={resetToEmail}>
                            {t("back")}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </div >
  );
}

export default LoginEmail;
